import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptTextToImage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPromptTextToImage"><Path d="M1.5 5V3.5H6H9.5V5" stroke="currentColor"/><Path d="M5.5 3.5V11.5M5.5 11.5H4M5.5 11.5H7" stroke="currentColor"/><Path d="M5.5 15V20.5H20.5V5.5H13" stroke="currentColor"/><Path d="M20.5 16L16 11.5L7 20.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconPromptTextToImage;
